export const PING_INTERVAL_DURATION = 30 * 1000;
export const TOOLTIP_TIMEOUT = 2 * 1000;
export const ROOM_ID_LENGTH = 8;